module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/unternehmensbewertung.json
// module id = 411
// module chunks = 261031248409386